var _g, _defs;
const _excluded = ["svgRef"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
const SvgIndicatorGray = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6999 8.9L13.3999 9.2C12.5999 9.2 11.8999 8.7 11.8999 7.9L11.5999 5.5H11.6999L15.6999 8.9Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6 17.7001C16.7 18.5001 16.1 19.2001 15.4 19.2001L7.89996 20.0001H7.79996H7.59996C6.79996 20.1001 6.09996 19.5001 6.09996 18.8001L4.99996 7.6001C4.89996 6.8001 5.49996 6.1001 6.19996 6.1001L11.5 5.6001H11.6L11.8 7.9001C11.8 8.1001 11.9 8.3001 12 8.4001C12.1 8.5001 12.2 8.7001 12.3 8.8001C12.6 9.1001 13 9.2001 13.4 9.2001H13.6H13.7L15.7 9.0001L16.6 17.7001Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3 8.9001L15.9 9.0001H15.8L14 9.2001C13.9 9.2001 13.8 9.2001 13.8 9.2001C13.1 9.2001 12.6 8.6001 12.5 8.0001L12.3 6.1001V6.0001V5.6001H12.4L16.3 8.9001Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6001 17.7001C16.7001 18.5001 16.1001 19.2001 15.4001 19.2001L7.90005 20.0001C7.30005 19.9001 6.70006 19.4001 6.70006 18.8001L5.60005 7.6001C5.50005 6.8001 6.10005 6.1001 6.80005 6.1001L11.6001 5.6001H11.7001H12.0001H12.1001V6.0001V6.1001L12.3001 7.9001C12.4001 8.6001 12.9001 9.1001 13.6001 9.1001C13.7001 9.1001 13.8001 9.1001 13.8001 9.1001L15.8001 9.0001L16.6001 17.7001Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 8.3H16.3C15.4 8.3 14.7 7.6 14.7 6.7V4L14.8 4.1L19 8.3Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9999 8.3V18.4C18.9999 19.3 18.2999 20 17.3999 20H8.4999C7.5999 20 6.8999 19.3 6.8999 18.4V5.6C6.8999 4.7 7.5999 4 8.4999 4H14.5999H14.6999V6.7C14.6999 7.6 15.3999 8.3 16.2999 8.3H18.9999Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 8.3V18.4C19 19.3 18.3 20 17.4 20H9.29995C8.39995 20 7.69995 19.3 7.69995 18.4V5.6C7.69995 4.7 8.39995 4 9.29995 4H14.6H14.7V6.7C14.7 7.6 15.4 8.3 16.3 8.3H19Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2001 12.8V9.5C11.6001 9.6 10.3001 10.8 10.1001 12.3C10.1001 12.5 10.3001 12.8 10.5001 12.8H13.2001Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4 16.6C12.4 16 12.4 14.3 12.4 13.7C12.4 13.6 12.3 13.5 12.2 13.5H9.50005C9.40005 13.5 9.30005 13.6 9.30005 13.7C9.40005 15.3 10.7 16.6 12.2 16.8C12.3 16.8 12.4 16.7 12.4 16.6Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1 10.9C15.5 10 14.5 9.5 13.4 9.5H13.3V12.8L16.1 10.9Z",
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6 12.8H13.2V15.8C13.2 16 13.3 16.1 13.5 16.1C15.3 16 16.6 14.5 16.6 12.8Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6 12.8C16.6 12.1 16.4 11.5 16 11L13.2 12.8H16.6Z",
    fill: "#999999"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIndicatorGray, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/IndicatorGray.b606f9d4.svg";
export { ForwardRef as ReactComponent };